/**
 * @generated SignedSource<<4c30d9c183f37476dd03eaad81eff95f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamSelectListItem_Team$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
  readonly " $fragmentType": "TeamSelectListItem_Team";
};
export type TeamSelectListItem_Team$key = {
  readonly " $data"?: TeamSelectListItem_Team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamSelectListItem_Team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamSelectListItem_Team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamIconCircleComponent_Team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "63d6983f0ad44beb9d1c9a9b89dffd2a";

export default node;
